<table class="subwindow" [cdkDragConstrainPosition]="constrainPosition" plessTitleWindowSub cdkDrag [windowMovable]="false" [windowResizable]="false" [frontDispFlag]="false">
  <tr class="subwindow-title" cdkDragHandle>
    <th class="window-title-name">週次プロモーション商品計画表</th>
  </tr>
  <tr class="subwindow-body">
    <td colspan="2">
      <div class="contents-area" (dragstart)="onDragstartBody($event)">
        <div class="column-list">
          <label class="list-input-title">使用受注コード</label>
          <div class="list-input-content">
            <div class="element-row">
              <app-order-code-text-input id="txt_StartOrderCode"
                [subid]="'txt_StartOrderCode'" [(ngModel)]="kymw4000Model.startOrderCode" [required]="true"
                [catalogIDField]="lbl_StartDelivCatalogId" [forcedEnabledMode]="'true'" [autofocus]="true" [tabindex]="0">
              </app-order-code-text-input>
              <label>～</label>
              <app-order-code-text-input id="txt_EndOrderCode"
                [subid]="'txt_EndOrderCode'" [(ngModel)]="kymw4000Model.endOrderCode" [required]="true"
                [catalogIDField]="lbl_EndDelivCatalogId" [forcedEnabledMode]="'true'" [tabindex]="0">
              </app-order-code-text-input>
            </div>  
          </div>

          <label class="list-input-title">使用配達企画回(翌週)</label>
          <div class="list-input-content">
            <div class="element-row">
              <input type="text" class="deliv-catalog" id="lbl_StartDelivCatalogId"
                #lbl_StartDelivCatalogId [readonly]="true" plessInputTextSub [restrict]="'[ -￮]'">
              <label>～</label>
              <input type="text" class="deliv-catalog" id="lbl_EndDelivCatalogId"
                #lbl_EndDelivCatalogId [readonly]="true" plessInputTextSub [restrict]="'[ -￮]'">
            </div>
          </div>

          <label class="list-input-title">プロモーション</label>
          <div class="list-input-content">
            <app-promotion-info-combo-box id="cmb_Promotion" #cmb_Promotion
              [subid]="'cmb_Promotion'" [(ngModel)]="kymw4000Model.promotionNo" [forcedEnabledMode]="'true'"
              [tabindex]="0">
            </app-promotion-info-combo-box>
          </div>
        </div>
      </div>  
    </td>
  </tr>
      
  <tfoot cdkDragHandle>
    <tr>
      <td>
        <div class="footer-buttons">
          <button id="btn_promotion" class="btn-secondary" 
            (click)="eventPromotion_CLICKHandler()" forcedEnabledMode="true" [tabindex]="0">プロモーション</button>
          <button id="btn_Output" class="btn-primary" 
            (click)="eventOutput_CLICKHandler()" forcedEnabledMode="true" [tabindex]="0">出力</button>
        </div>
        <div class="window-title-close">
          <button id="btn_Exit"
          (click)="onClickWindowClose()" forcedEnabledMode="true" [tabindex]="0"></button>
        </div>
      </td>
    </tr>
  </tfoot>
</table>